import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-akaun-discard-dialog",
  templateUrl: "./akaun-discard-dialog.component.html",
  styleUrls: ["./akaun-discard-dialog.component.scss"],
})
export class AkaunDiscardDialogComponent {
  public docNo: string;
  public confirmMessage: string;
  public title: string;
  public enteredDocNo: string;

  constructor(public dialogRef: MatDialogRef<AkaunDiscardDialogComponent>) {
    if (!this.title) {
      this.title = "Warning";
    }
  }
  onNoClick(): void {
    this.dialogRef.close(false);
  }

  checkDocNo(): void {
    if (this.enteredDocNo === this.docNo) {
      console.log("Document discarded:", this.docNo);
      this.dialogRef.close(true);
    }
  }
}
